const COMMON_URL = `${process.env.REACT_APP_COMMON_SERVICE_ORIGIN_URL}`

const MicrositeApiUrls = {
  GET_WEBSITE: `${COMMON_URL}/microsite/get-published-path-party-details`,
}

export default MicrositeApiUrls
